import styled from "styled-components";
const LayerBox = styled.div`
  flex: 0 0 100%;
  padding: 2em;
  height: 28px;
  margin-right: 10px !important;
  margin-top: 34vh !important;
  text-align: ${(props) =>
    props.center ? "center" : props.align ? props.align : "left"};
  @media (min-width: 40em) {
    flex: ${(props) => (props.width ? `0 0 ${props.width}` : 1)};
    width: ${(props) => (props.width ? props.width : "10%")};
    float: right;
  }
  @media (max-width: 600px) {
    margin-top: 64vh !important;
    margin-left: 340px !important;
  }
  /* Nokia Lumia 520*/
  @media only screen and (device-width: 320px) and (device-height: 533px) {
    margin-left: 190px !important;
    margin-top: 35vh !important;
    height: 18px;
  }
  /* iPhone 5SE */
  @media only screen and (device-width: 320px) and (device-height: 568px) {
    margin-top: 38vh !important;
    height: 5px;
    margin-left: 200px !important;
  }
  /* iPhone4 */
  @media only screen and (device-width: 320px) and (device-height: 480px) {
    margin-top: 28vh !important;
    height: 10px;
    margin-left: 170px !important;
  }
  /* Moto G4 & Microsoft Lumia 950 & Microsoft Lumia 550 & Galaxy S3 & Galaxy Note 2 & Galaxy Note 3 */
  @media only screen and (device-width: 360px) and (device-height: 640px) {
    margin-top: 40vh !important;
    height: 10px !important;
    margin-left: 170px !important;
    width: ${(props) => (props.width ? props.width : "50%")};
  }
  @media only screen and (device-width: 640px) and (device-height: 360px) {
    margin-top: 0vh !important;
    height: 10px !important;
    margin-left: 170px !important;
    width: ${(props) => (props.width ? props.width : "50%")};
  }
  /* LG Optimus */
  @media only screen and (device-width: 384px) and (device-height: 640px) {
    margin-top: 45vh !important;
    height: 10px !important;
    margin-left: 170px !important;
    width: ${(props) => (props.width ? props.width : "50%")};
  }
  /* iPhoneX */
  @media only screen and (device-width: 375px) and (device-height: 812px) {
    margin-top: 56vh !important;
    margin-left: 170px !important;
    height: 5px !important;
  }
  /* iPhone 6/7/8 */
  @media only screen and (device-width: 375px) and (device-height: 667px) {
    margin-top: 45vh !important;
    margin-left: 170px !important;
    height: 10px !important;
  }
  /* iPhone 6/7/8 Plus*/
  @media only screen and (device-width: 414px) and (device-height: 736px) {
    margin-top: 52vh !important;
    margin-left: 170px !important;
    height: 10px !important;
  }
  /* Pixel 2 XL */
  @media only screen and (device-width: 411px) and (device-height: 823px) {
    margin-top: 56vh !important;
    margin-left: 190px !important;
    height: 10px !important;
    width: ${(props) => (props.width ? props.width : "50%")};
  }
  @media only screen and (device-width: 411px) and (device-height: 731px) {
    margin-top: 52vh !important;
    margin-left: 190px !important;
    height: 10px !important;
  }
  /* Nexus 6 and Nexus 5X*/
  @media only screen and (device-width: 412px) and (device-height: 732px) {
    margin-top: 48vh !important;
    margin-left: 190px !important;
    width: ${(props) => (props.width ? props.width : "50%")};
  }
  /* Nokia N9*/
  @media only screen and (device-width: 480px) and (device-height: 854px) {
    margin-top: 60vh !important;
  }
  @media only screen and (device-width: 540px) and (device-height: 960px) {
    margin-top: 63vh !important;
  }
  /* Nexus 7*/
  @media only screen and (device-width: 600px) and (device-height: 960px) {
    margin-top: 64.5vh !important;
  }
  @media only screen and (device-width: 768px) and (device-height: 1024px) {
    margin-top: 58vh !important;
    margin-left: 190px !important;
    width: ${(props) => (props.width ? props.width : "15%")};
  }
  /* Nexus 10 & Kindle Fire HDx*/
  @media only screen and (device-width: 800px) and (device-height: 1280px) {
    margin-top: 67vh !important;
    width: ${(props) => (props.width ? props.width : "15%")};
  }
  @media only screen and (device-width: 1024px) and (device-height: 768px) {
    margin-top: 44vh !important;
    width: ${(props) => (props.width ? props.width : "15%")};
  }
  @media only screen and (device-width: 1024px) and (device-height: 1366px) {
    margin-top: 68vh !important;
    width: ${(props) => (props.width ? props.width : "15%")};
  }
  @media only screen and (device-width: 1440px) and (device-height: 789px) {
    margin-top: 48vh !important;
    width: ${(props) => (props.width ? props.width : "15%")};
  }
  /* Nokia Lumia 520*/
  @media only screen and (device-width: 1440px) and (device-height: 900px) {
    margin-top: 50vh !important;
  }
  /* Nexus 10 & Kindle Fire HDx*/
  @media only screen and (device-width: 1280px) and (device-height: 800px) {
    margin-top: 45vh !important;
    width: ${(props) => (props.width ? props.width : "15%")};
  }
  /* Laptop with touch */
  @media only screen and (device-width: 1280px) and (device-height: 950px) {
    margin-top: 55vh !important;
    width: ${(props) => (props.width ? props.width : "15%")};
  }
  /* 1536*2048 */
  @media only screen and (device-width: 1536px) and (device-height: 2048px) {
    margin-top: 68.5vh !important;
    width: ${(props) => (props.width ? props.width : "10%")};
  }
  @media only screen and (device-width: 1920px) and (device-height: 1080px) {
    margin-top: 59vh !important;
    width: ${(props) => (props.width ? props.width : "10%")};
  }
  @media only screen and (device-width: 2880px) and (device-height: 1800px) {
    margin-top: 79vh !important;
  }
`;

export default LayerBox;
